import axios from "axios";
import { API_URL } from "./utils";

const b64ToUint8 = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const getCurrentSubscription = async () => {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
};

// Pede permissão, subscreve no browser e regista no servidor (dispositivo deste utilizador)
export const subscribePush = async (prefs) => {
  if (!pushSupported()) throw new Error("Este navegador não suporta notificações push");
  const { data } = await axios.get(`${API_URL}/push/vapid-public-key`, { withCredentials: true });
  if (!data.enabled) throw new Error("Notificações push não configuradas no servidor");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permissão de notificações recusada no navegador");
  const reg = await navigator.serviceWorker.ready;
  const sub = (await reg.pushManager.getSubscription()) || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToUint8(data.key) }));
  const label = /android/i.test(navigator.userAgent) ? "Android" : /iphone|ipad/i.test(navigator.userAgent) ? "iPhone/iPad" : /windows/i.test(navigator.userAgent) ? "Windows" : /mac/i.test(navigator.userAgent) ? "Mac" : "Dispositivo";
  const r = await axios.post(`${API_URL}/push/subscribe`, { subscription: sub.toJSON(), prefs, device_label: `${label} · ${window.matchMedia("(display-mode: standalone)").matches ? "App instalada" : "Navegador"}` }, { withCredentials: true });
  return { sub, saved: r.data };
};

export const unsubscribePush = async () => {
  const sub = await getCurrentSubscription();
  if (!sub) return;
  await axios.delete(`${API_URL}/push/subscribe`, { params: { endpoint: sub.endpoint }, withCredentials: true }).catch(() => {});
  await sub.unsubscribe();
};
